import React, { useState } from 'react';
import ApartmentService from '../../../services/ApartmentService';

function SellApartmentComponent(props) {
    
    const getInitialState = () => {
        var temp = props.apartment;
        if(!temp.improvements){
            temp.improvements = 0;
        }
        if(!temp.adjusted_losore){
            temp.adjusted_losore = 0;
        }
        if(!temp.alm_losore){
            temp.alm_losore = 0;
        }
        if(!temp.special_conditions){
            temp.special_conditions = 0;
        }

        return ({ apartment: props.apartment });
    };

    const [state, setState] = useState(getInitialState());
    const [apartment] = useState(state.apartment);

    const putOnSale = (e) => {
        e.preventDefault();
        ApartmentService.saleApartment({...apartmentState, for_sale: true })
        .catch(function (err) {
            alert("Der opstod en fejl");
            console.log("Error saving", err);
        });
        props.salesClick();
    };

    const [apartmentState, setApartmentState] = useState(apartment);

    return <React.Fragment>
        {props.sellApartment &&
            <form className="apartmentForm " id="apartmentForm" onSubmit={putOnSale}>
                    <div className='col-md-12 slightMarginTopApartments'>

                        <div className="col-md-3 panelRowPadding ">
                            <div>
                                <label>Forbedringer</label>
                            </div>
                            <input className="form-control" name="type" value={apartmentState.improvements} onChange={(event) => setApartmentState({ ...apartmentState, improvements: event.target.value})} type="text" />
                        </div>
                        <div className="col-md-3 panelRowPadding ">
                            <div>
                                <label>Tilpassede løsøre</label>
                            </div>
                            <input className="form-control" name="type" value={apartmentState.adjusted_losore} onChange={(event) => setApartmentState({ ...apartmentState, adjusted_losore: event.target.value})} type="text" />
                        </div>
                        <div className="col-md-3 panelRowPadding ">
                            <div>
                                <label>Alm. løsøre</label>
                            </div>
                            <input className="form-control" name="type" value={apartmentState.alm_losore} onChange={(event) => setApartmentState({ ...apartmentState, alm_losore: event.target.value})} type="text" />
                        </div>
                        <div className="col-md-3 panelRowPadding ">
                            <div>
                                <label>Særlige forhold</label>
                            </div>
                            <input className="form-control" name="type" value={apartmentState.special_conditions} onChange={(event) => setApartmentState({ ...apartmentState, special_conditions: event.target.value})} type="text" />
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className="col-md-offset-6 col-md-3 panelRowPadding">
                            <button type="button" className="btn btn-primary" onClick={props.salesClick}>Afbryd</button>
                        </div>
                        <div className="col-md-3 panelRowPadding">
                            <button className="btn btn-primary" type="submit">{apartmentState.for_sale ? 'Rediger pris' : 'Sæt til salg'}</button>
                        </div>
                    </div>
                </form>}
    </React.Fragment>;
}
export default SellApartmentComponent;